import { render, staticRenderFns } from "./LmDatatableWithModalSelectorModalCreator.vue?vue&type=template&id=5b2885b6&scoped=true"
import script from "./LmDatatableWithModalSelectorModalCreator.vue?vue&type=script&lang=js"
export * from "./LmDatatableWithModalSelectorModalCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2885b6",
  null
  
)

export default component.exports